export default {
  noActiveRecipe: 'No active recipe on this furnace.',
};
